
// nastaveni pozic symbolu na valcich
import {cylinder_pos, icons_tmp, last_symbol, symbols} from "./mv81_config";
import {
    forcestopnow,
    reels_pos,
    server_result,
    server_config,
    behavior_config,
    ico_he, reels_lenghts
} from "../framework/src/engine/madnes/madnes_variables";
import {mv81_rotate_stop, stopposin, stopposin_old} from "./mv81_core";
import {madnes_get_pos_y, madnes_set_pos_y} from "../framework/src/engine/madnes/madnes_object";

export function mv81_print_reels()
{
    for(var i = 0; i < cylinder_pos.length; i++)
    {
        mv81_print_reel(i, reels_pos[i]);
    }
}

// nastaveni pozic symbolu na valci
export var result_lock = 0;
function mv81_print_reel(reel, pos)
{
    if(
        reel == 0 &&
        (
            symbols[reel] >= (behavior_config.reel.spin.duration - 2) ||
            forcestopnow === 1
        ) &&
        server_result != null &&
        stopposin[0] == -1 &&
        result_lock == 0 /*&&
		madnes_get_pos_y("reels_bufer_" + (cylinder_pos.length - 1) + "_S2") < 0*/&&
        madnes_get_pos_y("reels_bufer_" + 0 + "_S1") < 0
    )
    {
        mv81_rotate_stop();
    }

    while(pos * 1 >= ( ( reels_lenghts[reel] * 1 ) + 0 ) * ico_he)
    {
        pos -= ( ( reels_lenghts[reel] * 1 ) + 0 ) * ico_he;
    }

    while(pos * 1 < 0)
    {
        pos += ( ( reels_lenghts[reel] * 1 ) + 0 ) * ico_he;
    }

    icons_tmp[2] = Math.floor(pos / ico_he);

    if(server_config.logic.reels[reel][icons_tmp[2]] == null || typeof server_config.logic.reels[reel][icons_tmp[2]] == "undefined")
    {
        icons_tmp[2] = 0;
    }

    icons_tmp[0] = icons_tmp[2]+2;
    icons_tmp[1] = icons_tmp[2]+1;
    icons_tmp[3] = icons_tmp[2]-1;
    icons_tmp[4] = icons_tmp[2]-2;

    if(!isNaN(icons_tmp[2]) && last_symbol[reel] != icons_tmp[2])
    {
        last_symbol[reel] = icons_tmp[2];
        symbols[reel]++;
    }

    var t0 = pos - (ico_he * icons_tmp[2]) + 44 - ico_he;

    if(isNaN(t0))
    {
        return;
    }

    for(var i = 0; i <= 4; i++)
    {
        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] >= reels_lenghts[reel]
            )
        {
            icons_tmp[i] = icons_tmp[i] * 1 - reels_lenghts[reel] * 1;
        }

        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] < 0
            )
        {
            icons_tmp[i] = reels_lenghts[reel] * 1 + icons_tmp[i] * 1;
        }
    }

    var stop_tmp = stopposin_old;
    if(stop_tmp[reel] == null || stop_tmp[reel] == -1)
    {
        stop_tmp = stopposin;
    }

    if(stop_tmp[reel] != null && stop_tmp[reel] != -1)
    {
        for(var ii in icons_tmp)
        {
            if(
                icons_tmp[ii] >= ( stop_tmp[reel] % reels_lenghts[reel] ) - 1 &&
                icons_tmp[ii] <= ( stop_tmp[reel] % reels_lenghts[reel] ) + 1
            )
            {
                icons_tmp[ii] = "S" + ( icons_tmp[ii] - ( stop_tmp[reel] % reels_lenghts[reel] ) + 1 );
            }
            else if(
                stop_tmp[reel] % reels_lenghts[reel] == 0 &&
                icons_tmp[ii] + 1 >= reels_lenghts[reel]
            )
            {
                icons_tmp[ii] = "S" + ( ( icons_tmp[ii] - ( stop_tmp[reel] % reels_lenghts[reel] ) + 1 ) % reels_lenghts[reel] );
            }
            else if(
                stop_tmp[reel] % reels_lenghts[reel] == reels_lenghts[reel] - 1 &&
                icons_tmp[ii] == 0
            )
            {
                icons_tmp[ii] = "S" + ( ( icons_tmp[ii] - ( stop_tmp[reel] % reels_lenghts[reel] ) + 1 ) % reels_lenghts[reel] + reels_lenghts[reel] );
            }
        }
    }

    for(var i = 0; i <= 4; i++)
    {
        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] >= reels_lenghts[reel]
            )
        {
            icons_tmp[i] = icons_tmp[i] * 1 - reels_lenghts[reel] * 1;
        }

        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] < 0
            )
        {
            icons_tmp[i] = reels_lenghts[reel] * 1 + icons_tmp[i] * 1;
        }

    }

    for(var i = 0; i < reels_lenghts[reel]; i++)
    {
        madnes_set_pos_y("reels_bufer_" + reel + "_" + i, -9999);
        //madnes_set_pos_y("text_reels_bufer_" + reel + "_" + i, -9999);
    }

    for(var i = 0; i <= 2; i++)
    {
        madnes_set_pos_y("reels_bufer_" + reel + "_TMP" + i, -9999);
        madnes_set_pos_y("reels_bufer_" + reel + "_TMP2" + i, -9999);
    }

    for(var i = 0; i <= 2; i++)
    {
        madnes_set_pos_y("reels_bufer_" + reel + "_S" + i, -9999);
        //madnes_set_pos_y("text_reels_bufer_" + reel + "_S" + i, -9999);
    }

    for(var i = 0; i <= 4; i++)
    {
        madnes_set_pos_y("reels_bufer_"+reel+"_"+icons_tmp[i], t0 + ( ico_he * i ));
        //madnes_set_pos_y("text_reels_bufer_"+reel+"_"+icons_tmp[i], t0 + ( ico_he * i ));
    }
}
